import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Router from '../containers/Router'
import ToastsList from '../components/ToastsList'
import Modal from '../components/Modal'
import Version from '../components/Version'

import { app, ui } from '../redux'

class App extends Component {
    componentDidMount() {
        const { dispatch } = this.props
        dispatch(app.initialize())
    }

    render() {
        const { isInitialized, modal } = this.props
        if (!isInitialized) {
            return null
        }
        return (
            <div>
                <Router />
                <ToastsList />
                { modal && <Modal { ...modal } /> }
                <Version />
            </div>
        )
    }
}

App.propTypes = {
    dispatch      : PropTypes.func.isRequired,
    isInitialized : PropTypes.bool.isRequired,
    modal         : PropTypes.object
}


function mapStateToProps(state) {
    return {
        isInitialized : app.isInitialized(state),
        modal         : ui.getModal(state)
    }
}

export default connect(mapStateToProps)(App)
